export default __webpack_public_path__ + "static/media/Path3524.2fdc08ea.svg";